<div class="container">
  <h1>PA UI-KIT</h1>

  <div class="card">
    <p-tabs scrollable="true" lazy="true" [value]="activeTab" (valueChange)="handleTabChange($event)">
      <p-tablist>
        <pa-tab value="0">Кнопка</pa-tab>
        <pa-tab value="1">Поле ввода</pa-tab>
        <pa-tab value="2">Выбор из списка</pa-tab>
        <pa-tab value="3">Таблица</pa-tab>
        <pa-tab value="4">Меню</pa-tab>
        <pa-tab value="5">Тег</pa-tab>
        <pa-tab value="6">Список файлов</pa-tab>
        <pa-tab value="7">Пустой список</pa-tab>
        <pa-tab value="8">Выбор даты</pa-tab>
        <pa-tab value="9">Загрузка файлов</pa-tab>
        <pa-tab value="10">Текстовое поле</pa-tab>
        <pa-tab value="11">Toggle</pa-tab>
        <pa-tab value="12">Инфоблок</pa-tab>
        <pa-tab value="13">Кнопки выбора</pa-tab>
        <pa-tab value="14">Список данных</pa-tab>
        <pa-tab value="15">Счетчик</pa-tab>
        <pa-tab value="16">Вкладка</pa-tab>
        <pa-tab value="17">Toggle Button</pa-tab>
        <pa-tab value="18">Сообщение</pa-tab>
        <pa-tab value="19">Фильтры</pa-tab>
        <pa-tab value="20">Chip</pa-tab>
        <pa-tab value="21">Панель массовых действий</pa-tab>
        <pa-tab value="22">Text editor</pa-tab>
        <pa-tab value="23">Адрес ПВЗ</pa-tab>
        <pa-tab value="24">Диапазон выбора (slider range)</pa-tab>
        <pa-tab value="25">Степпер</pa-tab>
        <pa-tab value="26">Summary</pa-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel value="0">
          <app-button-view></app-button-view>
        </p-tabpanel>
        <p-tabpanel value="1">
          <app-input-view></app-input-view>
        </p-tabpanel>
        <p-tabpanel value="2">
          <app-select-view></app-select-view>
        </p-tabpanel>
        <p-tabpanel value="3">
          <app-table-view></app-table-view>
        </p-tabpanel>
        <p-tabpanel value="4">
          <app-menu-view></app-menu-view>
        </p-tabpanel>
        <p-tabpanel value="5">
          <app-tag-view></app-tag-view>
        </p-tabpanel>
        <p-tabpanel value="6">
          <app-file-list-view></app-file-list-view>
        </p-tabpanel>
        <p-tabpanel value="7">
          <app-empty-list-view></app-empty-list-view>
        </p-tabpanel>
        <p-tabpanel value="8">
          <app-datepicker-range-view></app-datepicker-range-view>
        </p-tabpanel>
        <p-tabpanel value="9">
          <app-uploadfile-view></app-uploadfile-view>
        </p-tabpanel>
        <p-tabpanel value="10">
          <app-textarea-view></app-textarea-view>
        </p-tabpanel>
        <p-tabpanel value="11">
          <app-toggle-switch-view></app-toggle-switch-view>
        </p-tabpanel>
        <p-tabpanel value="12">
          <app-info-block-view></app-info-block-view>
        </p-tabpanel>
        <p-tabpanel value="13">
          <app-select-button-view></app-select-button-view>
        </p-tabpanel>
        <p-tabpanel value="14">
          <app-data-list-view></app-data-list-view>
        </p-tabpanel>
        <p-tabpanel value="15">
          <app-counter-view></app-counter-view>
        </p-tabpanel>
        <p-tabpanel value="16">
          <app-tab-view></app-tab-view>
        </p-tabpanel>
        <p-tabpanel value="17">
          <app-toggle-button-view></app-toggle-button-view>
        </p-tabpanel>
        <p-tabpanel value="18">
          <app-message-view></app-message-view>
        </p-tabpanel>
        <p-tabpanel value="19">
          <app-filters-view></app-filters-view>
        </p-tabpanel>
        <p-tabpanel value="20">
          <app-chip-view></app-chip-view>
        </p-tabpanel>
        <p-tabpanel value="21">
          <app-bulk-actions-bar-view></app-bulk-actions-bar-view>
        </p-tabpanel>
        <p-tabpanel value="22">
          <app-editor-view></app-editor-view>
        </p-tabpanel>
        <p-tabpanel value="23">
          <app-pvz-address-input-view></app-pvz-address-input-view>
        </p-tabpanel>
        <p-tabpanel value="24">
          <app-slide-range-view></app-slide-range-view>
        </p-tabpanel>
        <p-tabpanel value="25">
          <app-stepper-view></app-stepper-view>
        </p-tabpanel>
        <p-tabpanel value="26">
          <app-summary-cards-view></app-summary-cards-view>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
